// extracted by mini-css-extract-plugin
module.exports = {"error_container":"ErrorBoundary_error_container__iKopN","btn_container":"ErrorBoundary_btn_container__N6RhF"};